module.exports = __webpack_public_path__ + "static/img/functionIcon.4d6e278.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/functionIcon.png
// module id = IsY6
// module chunks = 1